<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Input, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Types
	import type { VirtualComponentInterface } from 'src/types/VirtualComponents';

	export let additionalInputClass: string = '';
	export let settings: VirtualComponentInterface['config'];
	export let title: string = '';
	export let label: string = '';
</script>

<Text styleType="h2" class="mb-s">
	{title ||
		capFirstChar(
			$format('label_name', {
				default: 'Name',
			}),
		)}
</Text>
<Input
	aria-labelledby="input-5j4nz5i"
	size="m"
	class={additionalInputClass || 'mb-m'}
	icon="fas fa-cube"
	maxlength="255"
	{label}
	bind:value={settings.name}
	id="input-5j4nz5i"
/>
